var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('mt-swipe',{attrs:{"auto":4000}},_vm._l((_vm.banners),function(banner){return _c('mt-swipe-item',{key:banner.id},[_c('img',{staticClass:"banner_pic",attrs:{"src":banner.banner?banner.banner:banner.listPic}})])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-009a2cc9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/goodsCoupon/banner.vue
// module id = null
// module chunks = 